import { getSamlUrl } from 'shared/constants';
import userService from 'shared/services/user.service';
import { setPendingSsoUnlock } from 'src/utils/pending-sso-unlock';

/**
 * Redirect to the SSO login
 * @param {{authenticationMethodId: string, organizationId: string, loginHint?: string}} { authenticationMethodId, organizationId, loginHint }
 */
export function redirectToLoginWithSSO({ authenticationMethodId, organizationId, loginHint }) {
  // The callback URL carries only the code and user id, so on an unlock stash which org was
  // clicked: with a method shared across organizations the server would otherwise fall back
  // to the method's owner org. Only on an unlock — the sign-in flow uses this same helper,
  // and a value left behind by a login would be sent by a later unrelated callback (an
  // IdP-initiated login, a bookmarked IdP link) and rejected as "does not cover".
  if (userService.hasPersonalSession) {
    setPendingSsoUnlock(organizationId);
  }
  const url = getSamlUrl({ authenticationMethodId, organizationId, loginHint });
  window.location = url;
}
